/**
 * Load HubSpot only when a form approaches the viewport.
 *
 * @package ow-features
 */
( function () {
	'use strict';

	var scriptPromise = null;

	function loadHubspot() {
		if ( window.hbspt && window.hbspt.forms ) {
			return Promise.resolve();
		}

		if ( scriptPromise ) {
			return scriptPromise;
		}

		scriptPromise = new Promise( function ( resolve, reject ) {
			var script = document.createElement( 'script' );
			script.src = 'https://js.hsforms.net/forms/embed/v2.js';
			script.async = true;
			script.onload = resolve;
			script.onerror = reject;
			document.head.appendChild( script );
		} );

		return scriptPromise;
	}

	function improveAccessibility( el ) {
		el.querySelectorAll( 'a' ).forEach( function ( link ) {
			if ( 'here' === link.textContent.trim().toLowerCase() && link.href.indexOf( '/legal-and-privacy/' ) !== -1 ) {
				link.setAttribute( 'aria-label', 'Read the OpenWeb Legal and Privacy policy' );
			}
		} );
	}

	function hydrate( el ) {
		if ( ! el || el.dataset.initialized || el.dataset.loading ) {
			return;
		}

		var portalId = el.dataset.portalId;
		var formId = el.dataset.formId;
		if ( ! portalId || ! formId ) {
			return;
		}

		el.dataset.loading = '1';
		loadHubspot().then( function () {
			if ( ! ( window.hbspt && window.hbspt.forms ) || el.dataset.initialized ) {
				return;
			}

			var config = {
				portalId: portalId,
				formId: formId,
				target: '#' + el.id,
				onFormSubmit: function () {
					if ( window.dataLayer ) {
						window.dataLayer.push( {
							event: el.dataset.gtmEvent || 'formAction',
							cfEventTag: el.dataset.cfEventTag || '',
							cfEventTagParent: el.dataset.cfEventTagParent || '',
						} );
					}
				},
				onFormReady: function () {
					el.dataset.initialized = '1';
					delete el.dataset.loading;
					improveAccessibility( el );
					window.setTimeout( function () { improveAccessibility( el ); }, 250 );
					document.dispatchEvent( new CustomEvent( 'openweb:hubspot-form-ready', {
						detail: { element: el },
					} ) );
				},
			};

			if ( el.classList.contains( 'hubspot-form' ) ) {
				config.css = '';
			}

			window.hbspt.forms.create( config );
		} ).catch( function () {
			delete el.dataset.loading;
		} );
	}

	function boot() {
		var forms = Array.prototype.slice.call( document.querySelectorAll( '.ow-hubspot-form, .hubspot-form[data-form-id]' ) );
		if ( ! forms.length ) {
			return;
		}

		if ( ! ( 'IntersectionObserver' in window ) ) {
			forms.forEach( hydrate );
			return;
		}

		var observer = new IntersectionObserver( function ( entries ) {
			entries.forEach( function ( entry ) {
				if ( entry.isIntersecting ) {
					hydrate( entry.target );
					observer.unobserve( entry.target );
				}
			} );
		}, { rootMargin: '800px 0px' } );

		forms.forEach( function ( form ) { observer.observe( form ); } );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}
} )();
